import React, { useEffect, useState } from 'react';

import { PieChart, Pie, Sector, Cell, Tooltip } from 'recharts';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Legend, ResponsiveContainer } from 'recharts';
import { getMoodAnalyticData } from '../service/api';
import '../components/css/Dashboard-styles.css';
import '../components/css/team_mood.css';

import moment from 'moment';

const MoodAnalytic = (props) => {
    const [dataGraph, setData] = useState({});

    useEffect(() => {
        fetchApi(props);
    }, [props]);

    const fetchApi = async (props = {}) => {
        // //

        let resp;

        if (props.selectedMonth.month) {
            // //

            let dateObj = {
                startDate: moment(props.selectedMonth.month).startOf('month').format('YYYY-MM-DD'),
                endDate: moment(props.selectedMonth.month).endOf('month').format('YYYY-MM-DD'),
            };

            resp = await getMoodAnalyticData(dateObj);

        } else {

            resp = await getMoodAnalyticData();
        }

        if (resp?.data?.ResponseData) setData(resp.data.ResponseData);
        else {
            setData();
        }
    };

    const pieChart = (pieData) => {
        try {
            const data = [

                { name: 'Group B', value: Number(pieData.sad) },
                { name: 'Group C', value: Number(pieData.okay) },
                { name: 'Group A', value: Number(pieData.happy) },
            ];

            const COLORS = ['#D9649C', '#4466D8', '#30C681']; //happy 30C681 , sad D9649C , okay 4466D8

            return (
                <PieChart width={250} height={300} className="mood-analytic-chart2">
                    <Pie data={data} cx={120} cy={200} innerRadius={65} outerRadius={80} fill="#8884d8" paddingAngle={5} dataKey="value">
                        {data.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                        ))}
                    </Pie>
                </PieChart>
            );
        } catch (err) {

        }
    };

    const lineChart = (lineData) => {

        const data = [
            { name: '', happy: '', sad: '', okay: '' },
            { name: '', happy: '', sad: '', okay: '' },
            { name: '', happy: '', sad: '', okay: '' },
            { name: '', happy: '', sad: '', okay: '' },
        ];

        Object.keys(lineData).map((el, i) => {
            data[i].name = el;

            data[i].happy = lineData[el].happy;
            data[i].sad = lineData[el].sad;
            data[i].okay = lineData[el].okay;
        });

        return (
            <>
                <LineChart width={600} height={200} padding={{ top: 30 }} data={data} className="mood-line-chart">
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis
                        dataKey="name"
                        padding={{ left: 30, right: 30 }}
                        style={{
                            fontSize: '12px',
                            fontFamily: 'Times New Roman',
                        }}
                    />
                    <YAxis
                        style={{
                            fontSize: '12px',
                            fontFamily: 'Times New Roman',
                        }}
                    />
                    {/* <Legend /> */}
                    <Line dataKey="sad" stroke="#D9649C" activeDot={{ r: 8 }} />
                    <Line dataKey="okay" stroke="#4466D8" activeDot={{ r: 8 }} />
                    <Line dataKey="happy" stroke="#30C681" activeDot={{ r: 8 }} />

                </LineChart>
            </>
        );
    };

    const moodEmojie = (moodData) => {
        if (moodData.happy >= moodData.sad && moodData.happy >= moodData.okay) {
            return (
                <div className=''>
                    <img src="/Images/happy-emoji.png" className="mood-emoji" />
                    <h1 class="tt-bold-text font-14 text-center">Happy</h1>
                </div>
            );
        } else if (moodData.okay >= moodData.happy && moodData.okay >= moodData.sad) {
            return (
                <div>
                    <img src="/Images/Ok.png" className="mood-emoji" />
                    <h1 class="tt-bold-text font-14 text-center">Okay</h1>
                </div>
            );
        } else {
            return (

                <div>
                    <img src="/Images/Sad.png" className="mood-emoji" />
                    <h1 class="tt-bold-text font-14 text-center">Sad</h1>
                </div>

            );
        }
    };

    const objectMapping = () => {
        try {
            return Object.keys(dataGraph).map((reason) => {
                return (
                    <div class="row bg-white mood-border-radius mb-4">
                        <div class="col-md-4 p-4">
                            <h1 class="font-14 bold-text">{reason}</h1>

                            <div class="row">
                                <div class="col-md-8">{pieChart(dataGraph[reason].pie)}</div>
                                <div class="col-md-3" style={{ 'margin-top': '40px' }}>
                                    <div>
                                        <label className="regular-text font-10 me-2">
                                            <span className="happy-legend me-2" />
                                            {`Happy (${dataGraph[reason].pie.happy}%)`}
                                        </label>
                                    </div>
                                    <div>
                                        <label className="regular-text font-10 me-4">
                                            <span className="sad-legend me-2" />
                                            {`Sad (${dataGraph[reason].pie.sad}%)`}
                                        </label>
                                    </div>
                                    <div>
                                        <label className="regular-text font-10 me-4">
                                            <span className="okay-legend me-2" />
                                            {`Ok (${dataGraph[reason].pie.okay}%)`}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 p-4 text-center position-relative">
                            <span className='a-yaxis-style'>Percentage</span>
                            <span className='a-xaxis-style'>Date Range</span>
                            {lineChart(dataGraph[reason].bar)}
                        </div>

                        <div class="col-md-2 p-4  d-flex justify-content-center align-self-center">{moodEmojie(dataGraph[reason].pie)}</div>
                    </div>
                );
            });
        } catch (e) {

        }
    };

    return (
        <>
            {dataGraph ? (
                objectMapping()
            ) : (
                <div className="row justify-content-center">
                    <img
                        src="/Images/vadivelu.png"
                        alt="nodatafound"
                        className="nofeedbackimg-sty"
                        style={{ height: '500px', width: '750px' }}
                    />

                    <h2 className="tt-bold font-15 text-center">No Records Found</h2>
                </div>
            )}
        </>
    );
};

export default MoodAnalytic;
